import React, { useContext } from "react";
import styles from "./styles.module.scss";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Navbar from "app/components/Navbar";
import { UserContext, RoleType } from "app/contexts/UserContext";

type PropsDef = {
  returnTo?: string;
};

export default function ReturnBar(props: PropsDef) {
  const { t } = useTranslation();
  const history = useHistory();
  const user = useContext(UserContext);

  const isAdminOrScheduler = user.behavesLikeAdmin || user.role === RoleType.SCHEDULER;
  const defaultReturn = isAdminOrScheduler ? "/calendar/facility" : "/calendar";
  const { returnTo = defaultReturn } = props;

  const handleIconClick = () => {
    history.push(returnTo);
  };

  return (
    <Navbar
      hasSearch={false}
      hasNotifications={false}
      onBackClick={handleIconClick}
      label={t("Calendar Settings")}
      hasMobileView={true}
      className={styles.navbar}
    />
  );
}
